module.exports = __webpack_public_path__ + "static/img/static_bg2.3f9d0f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/static_bg2.png
// module id = OSCF
// module chunks = 37